import gql from 'graphql-tag';

export default gql`
  mutation removeByIdHomeTaskMutation($_id: MongoID!) {
    removeByIdHomeTaskMutation(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
